const C = {
  name: "Image",
  dimensions: { width: 40, height: 40 },
  content: `
    <g clip-path="url(#clip0_31_41)">
    <path d="M35 0H5C2.24 0 0 2.24 0 5V35C0 37.76 2.24 40 5 40H35C37.76 40 40 37.76 40 35V5C40 2.24 37.76 0 35 0ZM38 35C38 36.65 36.65 38 35 38H5C3.35 38 2 36.65 2 35V5C2 3.35 3.35 2 5 2H35C36.65 2 38 3.35 38 5V35Z" fill="currentColor"/>
    <path d="M27 18C29.76 18 32 15.76 32 13C32 10.24 29.76 8 27 8C24.24 8 22 10.24 22 13C22 15.76 24.24 18 27 18ZM27 10C28.65 10 30 11.35 30 13C30 14.65 28.65 16 27 16C25.35 16 24 14.65 24 13C24 11.35 25.35 10 27 10Z" fill="currentColor"/>
    <path d="M27.71 22.29C27.32 21.9 26.69 21.9 26.3 22.29L22.01 26.58L10.71 15.29C10.32 14.9 9.69 14.9 9.3 15.29L4.3 20.29C4.11 20.48 4.01 20.73 4.01 21V35C4.01 35.55 4.46 36 5.01 36H35.01C35.56 36 36.01 35.55 36.01 35V31C36.01 30.73 35.9 30.48 35.72 30.29L27.72 22.29H27.71ZM34 34H6V21.41L10 17.41L21.29 28.7C21.68 29.09 22.31 29.09 22.7 28.7L26.99 24.41L33.99 31.41V34H34Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_31_41">
    <rect width="40" height="40" fill="currentColor" transform="translate(0.00292969 0.00292969)"/>
    </clipPath>
    </defs>
  `
};
export {
  C as Image
};
